/* eslint-disable */

import { ApplicationInsights, SeverityLevel } from '../../ReactComponents/ApplicationInsights';

export var epiRecommendations = function (settings: any) {
    return {
        track: function (trackingData: any, scope: any, channel: any, onSuccess: any, callbackOptions: any) {
            if (typeof settings === 'undefined') {
                return;
            }
            trackingData.scope = typeof scope === 'undefined' ? null : scope;
            trackingData.channel = typeof channel === 'undefined' ? null : channel;
            this._sendTrackingData(trackingData, onSuccess, callbackOptions);
        },
        _sendTrackingData: function (trackingData: any, onSuccess: any, callbackOptions: any) {
            var proxyUrl = settings.endPointUrl;
            if (!proxyUrl || this._isEmpty(trackingData)) {
                return;
            }
            if (!trackingData.lang) {
                trackingData.lang = settings.preferredCulture;
            }
            // @ts-ignore
            this._post(proxyUrl, JSON.stringify(trackingData), function (response: any) {
                typeof onSuccess === 'function' && onSuccess(response, callbackOptions);
            });
        },
        _isEmpty: function (obj: any) {
            return obj === undefined || obj === null || (Object.keys(obj).length === 0 && obj.constructor === Object);
        },
        _post: function (url: any, data: any, onSuccess: any, async: any) {
            this._send('POST', url, data, onSuccess, async);
        },
        _send: function (method: any, url: any, data: any, onSuccess: any, async: any) {
            if (typeof async === 'undefined') {
                async = true;
            }
            var xhr = this._getXHR();
            xhr.open(method, url, async);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200 && typeof onSuccess === 'function') {
                        onSuccess(xhr.responseText);
                    }
                    if (xhr.status >= 400) {
                        ApplicationInsights.TrackTrace(SeverityLevel.Error, `VisitorIntelligence script error: Received unsuccessful response: ${xhr.status} ${xhr.responseText}`);
                    }
                }
            };
            xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhr.send(data);
        },
        _getXHR: function () {
            if (typeof XMLHttpRequest !== 'undefined') {
                return new XMLHttpRequest();
            }
            var vers = ['MSXML2.XmlHttp.6.0', 'MSXML2.XmlHttp.5.0', 'MSXML2.XmlHttp.4.0', 'MSXML2.XmlHttp.3.0', 'MSXML2.XmlHttp.2.0', 'Microsoft.XmlHttp'];
            for (var i = 0, length = vers.length; i < length; i++) {
                try {
                    // @ts-ignore
                    return new ActiveXObject(vers[i]);
                } catch (err: any) {
                    ApplicationInsights.TrackTrace(SeverityLevel.Error, `VisitorIntelligence script error: ${err.message}`);
                }
            }
            // @ts-ignore
            return new XMLHttpRequest();
        }
    };
};
export var TrackingDataFactory = {
    createHomeTrackingData: function () {
        return this._createTrackingDataBase('home');
    },
    createProductTrackingData: function (productCode: any, productName: any) {
        const trackingData = this._createTrackingDataBase('product');
        trackingData.productCode = productCode;
        trackingData.contentName = productName;
        return trackingData;
    },
    createSearchResultTrackingData: function (term: any, productCodes: any, totalResultCount: any) {
        const trackingData = this._createTrackingDataBase('searchresults');
        trackingData.searchResults = {
            term: term,
            productCodes: productCodes,
            totalNumberOfResults: totalResultCount
        };
        return trackingData;
    },
    createCheckoutTrackingData: function () {
        return this._createTrackingDataBase('checkout');
    },
    createBasketTrackingData: function () {
        const basketTracking = this._createTrackingDataBase('basket');
        return basketTracking;
    },
    createOrderTrackingData: function (orderId: any) {
        const orderTrackingData = this._createTrackingDataBase('order');
        orderTrackingData.orderId = orderId;
        return orderTrackingData;
    },
    createBrandTrackingData: function (brandName: any) {
        const trackingData = this._createTrackingDataBase('brand');
        trackingData.brand = brandName;
        return trackingData;
    },
    createCategoryTrackingData: function (categoryCode: any) {
        const trackingData = this._createTrackingDataBase('category');
        trackingData.category = categoryCode;
        return trackingData;
    },
    createAttributeTrackingData: function (attributeName: any, attributeValue: any) {
        const trackingData = this._createTrackingDataBase('attribute');
        trackingData.attribute = {
            name: attributeName,
            value: attributeValue
        };
        return trackingData;
    },
    createWishlistTrackingData: function () {
        return this._createTrackingDataBase('wishlist');
    },
    _createTrackingDataBase: function (type: any): any {
        return {
            type: type,
            currentUri: window.location.href,
            previousUri: document.referrer,
            customAttributes: {}
        };
    }
};
